var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("translates", {
    attrs: {
      item: this.categ,
      item_id: parseInt(_vm.categ.id),
      item_type: "category",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }